import { defineComponent as _defineComponent } from 'vue'
import BuyBoxUpcomingNew from '@/components/buybox-new/BuyBoxUpcomingNew.vue';
import type { UpcomingReleaseBuybox } from '@/components/buybox-new/types.ts';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { BuyBoxFilterOptions } from '@/stores/user.store';
import { SnowplowContext } from '@/helpers/tracking/providers';
import BuyBoxNoOffersNew from '@/components/buybox-new/BuyBoxNoOffersNew.vue';
import BuyBoxNotifyMeNew from '@/components/buybox-new/BuyBoxNotifyMeNew.vue';
import BuyBoxPromotionRowNew from './BuyBoxPromotionRowNew.vue';
import { computed } from 'vue';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { allowedPromotionLanguages, usePromotion } from '@/helpers/composables/usePromotion';
import { useBuyboxLoggedInExp } from '../experiments/BuyboxLoggedInExp/composables/useBuyboxLoggedInExp';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxUpcomingWithNoOffers',
  props: {
    upcomingReleases: null,
    hasUpcomingReleases: { type: Boolean },
    title: null,
    isTitleInWatchlist: { type: Boolean },
    filter: null,
    additionalContexts: null,
    seasonNumber: null
  },
  emits: ["onNotifyMe"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'onNotifyMe'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	upcomingReleases: UpcomingReleaseBuybox[];
	hasUpcomingReleases: boolean;
	title: TitleDetail;
	isTitleInWatchlist?: boolean;
	filter: BuyBoxFilterOptions;
	additionalContexts: SnowplowContext[];
	seasonNumber?: number | null;
};





const { language } = useLanguageStore();

const { promotionOffer } = usePromotion({
	title: () => props.title,
	offers: () => [],
});

const showFreeTrial = computed(
	() =>
		!!promotionOffer.value &&
		[BuyBoxFilterOptions.ALL, BuyBoxFilterOptions.FREE, BuyBoxFilterOptions.SUBSCRIPTION].includes(props.filter) &&
		// splitting language for locale specific ones like Spanish - Spain, Spanish - Latin America, etc
		allowedPromotionLanguages.includes(language.value.split('-')[0])
);

const { trackBuyboxLoggedInExp } = useBuyboxLoggedInExp();
function trackClickout() {
	trackBuyboxLoggedInExp({
		action: 'click',
		label: 'free_trial_clickout_upcoming_new_buybox',
	});
}

return { __sfc: true,props, emit, language, promotionOffer, showFreeTrial, trackBuyboxLoggedInExp, trackClickout, BuyBoxUpcomingNew, BuyBoxNoOffersNew, BuyBoxNotifyMeNew, BuyBoxPromotionRowNew }
}

})